import {
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../App";
import { Button, Input } from "../../../controls";
import { IsEmptyObj, PrintDiv, ToFormData } from "../../../hooks/Method";
import { Alert } from "../../../layout";
import { useTranslation } from "react-i18next";
import { CloseRounded } from "@mui/icons-material";
import PrintRegReport from "../PrintRegReport";
import { action, controller, Server } from "../../../api/Server";
import moment from "moment";

const CloseRegWithDetails = ({ setShowForm }) => {
  const { t } = useTranslation();
  const { setLoader, settings, authUser } = useContext(AppContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [sells, setSells] = useState([]);
  const [cancelCarts, setCancelCarts] = useState([]);
  const [voidSells, setVoidSells] = useState([]);
  const [openData, setOpenData] = useState({});
  const [totalSells, setTotalSells] = useState(0);
  const [average, setAverage] = useState(0);
  const [refund, setRefund] = useState(0);
  const [voidAmount, setVoidAmount] = useState(0);
  const [cashSale, setCashSale] = useState(0);
  const [craditSale, setCraditSale] = useState(0);
  const [taxItem, setTaxItem] = useState(0);
  const [nonTaxItem, setNonTaxItem] = useState(0);
  const [taxReceived, setTaxReceived] = useState(0);
  const [otherPayment, setOtherPayment] = useState(0);
  const [totalDiffAmt, setTotalDiffAmt] = useState(0);
  const [expense, setExpense] = useState([]);
  const [soldByCats, setSoldByCats] = useState([]);
  const [notes, setNotes] = useState("");
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const { selStore, stores } = useContext(AppContext);
  const [store, setStore] = useState({});

  useEffect(() => {
    setStore(stores.find((j) => j.id === selStore));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selStore]);

  useEffect(() => {
    var posOpenData = JSON.parse(localStorage.getItem("posOpen")) || [];
    var posOpen = posOpenData.find((j) => j.storeId === selStore);
    if (posOpen) {
      setOpenData(posOpen);
      setLoader(true);
      const onComplete = (res) => {
        if (res.status === 200) {
          setSells(res.result.sells);
          setVoidSells(res.result.voidSells);
          setCancelCarts(res.result.cancelCarts);
          setExpense(res.result.expense);
        }
        setLoader(false);
      };

      Server(controller.Sell + action.CloseRegSells).post(
        ToFormData({
          userId: authUser.id,
          storeId: posOpen.storeId,
          dateTime: new Date(posOpen.timeIn).toISOString(),
        }),
        onComplete
      );
    } else {
      setAlert({
        isOpen: true,
        type: "warning",
        title: "Register closed",
        subTitle: "This register is currently closed.",
        onClick: () => setShowForm(false),
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (sells.length > 0) {
      var _total = sells
        .map((j) => j.subtotal + j.tax)
        .reduce((x, y) => x + y, 0);
      setTotalSells(_total.toFixed(settings.decimal));
      setAverage((_total / sells.length).toFixed(settings.decimal));
      setTotalDiffAmt(sells.map((j) => j.diffAmt).reduce((x, y) => x + y, 0));

      var _taxItem = sells
        .map(
          (j) =>
            j.sellItems.filter((x) => x.itemType === 1 && x.product.tax === 1)
              .length
        )
        .reduce((x, y) => x + y, 0);
      setTaxItem(_taxItem.toFixed(settings.decimal));

      var _nonTaxItem = sells
        .map(
          (j) =>
            j.sellItems.filter((x) => x.itemType === 2 || x.product.tax === 2)
              .length
        )
        .reduce((x, y) => x + y, 0);
      setNonTaxItem(_nonTaxItem.toFixed(settings.decimal));

      var _taxReceived = sells.map((j) => j.tax).reduce((x, y) => x + y, 0);
      setTaxReceived(_taxReceived.toFixed(settings.decimal));

      var _totalCashSale = sells
        .filter(
          (j) => j.payMethod && j.payMethod.title.toLowerCase().includes("cash")
        )
        .map((j) => j.received - j.change)
        .reduce((x, y) => x + y, 0);
      setCashSale(_totalCashSale.toFixed(settings.decimal));

      var _totalCraditSale = sells
        .map((j) => j.creditAmt)
        .reduce((x, y) => x + y, 0);
      setCraditSale(_totalCraditSale.toFixed(settings.decimal));

      setOtherPayment(
        (_total - (_totalCashSale + _totalCraditSale)).toFixed(settings.decimal)
      );

      var _refunds = voidSells
        .filter((j) => j.cancelType === 2)
        .map((j) => j.subtotal + j.tax)
        .reduce((x, y) => x + y, 0);
      setRefund(_refunds.toFixed(settings.decimal));

      var _voidAmount = voidSells
        .filter((j) => j.cancelType === 1)
        .map((j) => j.subtotal + j.tax)
        .reduce((x, y) => x + y, 0);
      setVoidAmount(_voidAmount.toFixed(settings.decimal));

      // Sold By Categories
      const _soldByCats = [];
      // Lottery
      const lottery = sells
        .map((j) => j.sellItems.filter((x) => x.itemType === 2))
        .flat();
      lottery.length > 0 && _soldByCats.push(lottery);
      // Product
      const prod = sells
        .map((j) => j.sellItems.filter((x) => x.itemType === 1))
        .flat();

      prod.forEach((j) => {
        var item = prod.filter(
          (x) => x.product.categoryId === j.product.categoryId
        );
        !_soldByCats.some((x) => JSON.stringify(x) === JSON.stringify(item)) &&
          _soldByCats.push(item);
      });
      setSoldByCats(_soldByCats);
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sells]);

  const onComplete = (res) => {
    setLoading(false);
    if (res.status === 201)
      setAlert({
        isOpen: true,
        type: "success",
        title: t("success"),
        subTitle: t("regClosedSuccessTitle"),
        onClick: () => {
          PrintDiv("PrintRegReport");
          // Get All opened registers from localStorage
          var openRegisters = JSON.parse(localStorage.getItem("posOpen")) || [];
          // Remove the closed register from localStorage
          openRegisters.filter((j) => j.storeId !== selStore);
          // Update localStorage with the remaining opened registers
          localStorage.setItem("posOpen", JSON.stringify(openRegisters));
          // Reset the state and navigate to POS
          setShowForm(false);
          navigate("/");
        },
      });
    else
      setAlert({
        isOpen: true,
        type: "error",
        title: t("error"),
        subTitle: res.msg,
      });
  };

  const handleClose = () => {
    if (!IsEmptyObj(openData)) {
      setLoading(true);
      const regData = {
        id: 0,
        storeId: store.id,
        userId: authUser.id,
        openTime: openData.timeIn,
        totalSale: totalSells,
        totalCash: cashSale,
        totalCradit: craditSale,
        totalRefund: refund,
        totalVoidSell: voidAmount,
        itemCancel: cancelCarts.length,
        notes: notes,
        otherPayment: otherPayment,
        taxItemSold: taxItem,
        nonTaxItemSold: nonTaxItem,
        taxReceived: taxReceived,
        averagePerCstmr: average,
        totalCstmr: sells.length,
        shiftTransBalanace: openData.cashInDrawer,
        multiPayAmt: openData.multiPayAmt,
        multPays: openData.multPays,
        totalDiffAmt: totalDiffAmt,
        closeTime: new Date().toISOString(),
      };

      Server(controller.Register).post(ToFormData(regData), onComplete);
    } else {
      setAlert({
        isOpen: true,
        type: "warning",
        title: t("warning"),
        subTitle: t("regCloseWarning"),
      });
    }
  };

  return (
    <>
      <Box className="d-none" id="PrintRegReport">
        <PrintRegReport
          {...{
            totalSells,
            average,
            refund,
            voidAmount,
            cashSale,
            craditSale,
            taxItem,
            nonTaxItem,
            taxReceived,
            store,
            authUser,
            expense,
            soldByCats,
            sells,
            openData,
            cancelCarts,
            otherPayment,
          }}
        />
      </Box>

      <div className="tx-center d-flex j-between a-center p-10">
        <span className="fs-22 gray-color tx-upp border-left">
          {t("cashRegisterReport")}
        </span>
        <IconButton color="error" onClick={() => setShowForm(false)}>
          <CloseRounded />
        </IconButton>
      </div>
      <Divider />
      {settings ? (
        <Grid container spacing={3} className="p-10">
          <Grid item xs={12}>
            <Box
              className="d-flex j-between"
              sx={{ flexWrap: { xs: "wrap", md: "inherit" } }}
            >
              {/* Cashier Details */}
              <Box className="mt-20 mb-30 w-100pr" sx={{ mr: { md: "20px" } }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "16px", md: "18px" },
                    borderLeft: "0.4rem double var(--primary-color)",
                    paddingLeft: "10px",
                  }}
                  className="tx-upp gray-color"
                >
                  {t("cashierDetails")}
                </Typography>
                <Divider className="pt-10 mb-5" />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "140px", md: "180px" } }}
                  >
                    {t("storeName")}:
                  </Typography>
                  <Typography variant="subtitle1">{store.storeName}</Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "140px", md: "180px" } }}
                  >
                    {t("address")}:
                  </Typography>
                  <Typography variant="subtitle1">{store.address}</Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "140px", md: "180px" } }}
                  >
                    {t("cashierName")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {authUser.fullName}
                  </Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "140px", md: "180px" } }}
                  >
                    {t("timeIn")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {moment(openData.timeIn, "M/D/YYYY, h:mm:ss A").format(
                      "DD MMMM, YYYY, hh:mm:A"
                    )}
                  </Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "140px", md: "180px" } }}
                  >
                    {t("timeOut")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {moment().format("DD MMMM, YYYY, hh:mm:A")}
                  </Typography>
                </Box>
                <Divider />
              </Box>
              {/* Register Details */}
              <Box className="mt-20 mb-30 w-100pr">
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "16px", md: "18px" },
                    borderLeft: "0.4rem double var(--primary-color)",
                    paddingLeft: "10px",
                  }}
                  className="tx-upp gray-color"
                >
                  {t("registerDetails")}
                </Typography>
                <Divider className="pt-10 mb-5" />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalCustomers")}:
                  </Typography>
                  <Typography variant="subtitle1">{sells.length}</Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("averagePerCustomer")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings && settings.curSymbol} {average}
                  </Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalSaleRefund")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings && settings.curSymbol} {refund}
                  </Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalVoidSells")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings.curSymbol + " " + voidAmount}
                  </Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalItemCanceled")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {cancelCarts.length}
                  </Typography>
                </Box>
                <Divider />
              </Box>
            </Box>

            <Box
              className="d-flex j-between"
              sx={{ flexWrap: { xs: "wrap", md: "inherit" } }}
            >
              {/* Sale Report */}
              <Box className="mt-20 mb-30 w-100pr" sx={{ mr: { md: "20px" } }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "16px", md: "18px" },
                    borderLeft: "0.4rem double var(--primary-color)",
                    paddingLeft: "10px",
                  }}
                  className="tx-upp gray-color"
                >
                  {t("saleReport")}
                </Typography>
                <Divider className="pt-10 mb-5" />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalSale")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings.curSymbol + " " + totalSells}
                  </Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalCashSale")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings.curSymbol + " " + cashSale}
                  </Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalCreditSale")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings.curSymbol + " " + craditSale}
                  </Typography>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("otherPaymentReceived")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {" "}
                    {settings.curSymbol + " " + otherPayment}
                  </Typography>
                </Box>
              </Box>
              {/* Sell Details */}
              <Box className="mt-20 mb-30 w-100pr">
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "16px", md: "18px" },
                    borderLeft: "0.4rem double var(--primary-color)",
                    paddingLeft: "10px",
                  }}
                  className="tx-upp gray-color"
                >
                  {t("sellDetails")}
                </Typography>
                <Divider className="pt-10 mb-5" />

                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalGrossSale")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings.curSymbol + " " + totalSells}
                  </Typography>
                </Box>
                <Divider />

                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalTaxItemSold")}:
                  </Typography>
                  <Typography variant="subtitle1">{taxItem}</Typography>
                </Box>

                <Divider />

                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalNonTaxItemSold")}:
                  </Typography>
                  <Typography variant="subtitle1">{nonTaxItem}</Typography>
                </Box>

                <Divider />

                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "180px", md: "200px" } }}
                  >
                    {t("totalTaxReceived")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings.curSymbol + " " + taxReceived}
                  </Typography>
                </Box>
              </Box>
              <Divider />
            </Box>
            <Box
              className="d-flex j-between"
              sx={{ flexWrap: { xs: "wrap", md: "inherit" } }}
            >
              {/* Money */}
              <Box className="mt-20 mb-30 w-100pr" sx={{ mr: { md: "20px" } }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "16px", md: "18px" },
                    borderLeft: "0.4rem double var(--primary-color)",
                    paddingLeft: "10px",
                  }}
                  className="tx-upp gray-color"
                >
                  {t("money")}
                </Typography>
                <Divider className="pt-10 mb-5" />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "220px", md: "250px" } }}
                  >
                    {t("totalCashSale")}:
                  </Typography>
                  <Typography variant="subtitle1">
                    {settings.curSymbol + " " + totalSells}
                  </Typography>
                </Box>
                <Divider />
                {expense.map((exp, i) => (
                  <Box key={i}>
                    <Box className="d-flex">
                      <Typography
                        variant="subtitle1"
                        className="fw-5"
                        sx={{ minWidth: { xs: "220px", md: "250px" } }}
                      >
                        {exp.expenseCat.name}:
                      </Typography>
                      <Typography variant="subtitle1">
                        {settings.curSymbol + " " + exp.amount}
                      </Typography>
                    </Box>
                    <Divider />
                  </Box>
                ))}
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "220px", md: "250px" } }}
                  >
                    {t("totalShiftTransactionsBalance")}:
                  </Typography>
                  <div className="d-flex a-center g-10">
                    <Typography variant="subtitle1">
                      {" "}
                      -{settings.curSymbol + " " + openData.cashInDrawer}
                    </Typography>{" "}
                  </div>
                </Box>
                <Divider />
                <Box className="d-flex">
                  <Typography
                    variant="subtitle1"
                    className="fw-5"
                    sx={{ minWidth: { xs: "220px", md: "250px" } }}
                  >
                    {t("totalDiffAmt")}:
                  </Typography>
                  <div className="d-flex a-center g-10">
                    <Typography variant="subtitle1">
                      {" "}
                      -
                      {settings.curSymbol +
                        " " +
                        totalDiffAmt.toFixed(settings.decimal)}
                    </Typography>{" "}
                  </div>
                </Box>
                <Divider />
              </Box>
            </Box>

            {/* Products Sold by Category */}
            <TableContainer className="mt-20">
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "16px", md: "18px" },
                  borderLeft: "0.4rem double var(--primary-color)",
                  paddingLeft: "10px",
                  marginBottom: "10px",
                }}
                className="gray-color tx-upp"
              >
                {t("productsSoldByCategory")}
              </Typography>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow
                    sx={{
                      "&:last-child td, &:last-child th": { padding: "0px" },
                    }}
                  >
                    <TableCell>{t("categoryName")}</TableCell>
                    <TableCell>{t("quantity")}</TableCell>
                    <TableCell>{t("price")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {soldByCats.map((item, i) => (
                    <TableRow key={i} sx={{ "td, th": { padding: "5px 0px" } }}>
                      <TableCell>
                        {item[0].itemType === 1
                          ? item[0].product.category !== null
                            ? item[0].product.category.name
                            : t("others")
                          : t("lottery")}
                      </TableCell>
                      <TableCell>
                        {item.map((j) => j.qty).reduce((x, y) => x + y, 0)}
                      </TableCell>
                      <TableCell>
                        {settings.curSymbol +
                          " " +
                          item
                            .map((j) => j.qty * j.price)
                            .reduce((x, y) => x + y, 0)
                            .toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Details of products sold */}
            <TableContainer className="mt-20">
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "16px", md: "18px" },
                  borderLeft: "0.4rem double var(--primary-color)",
                  paddingLeft: "10px",
                  marginBottom: "10px",
                }}
                className="gray-color tx-upp"
              >
                {t("detailsOfProductsSold")}
              </Typography>
              <Box sx={{ maxHeight: "300px !important", overflow: "auto" }}>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { padding: "0px" },
                      }}
                    >
                      <TableCell>{t("itemName")}</TableCell>
                      <TableCell className="w-70">{t("quantity")}</TableCell>
                      <TableCell className="w-90">{t("tax")}</TableCell>
                      <TableCell>{t("price")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sells
                      .map((j) => j.sellItems)
                      .flat()
                      .map((item, i) => (
                        <TableRow
                          sx={{ "td, th": { padding: "5px 0px" } }}
                          key={i}
                        >
                          <TableCell>{item.product.name}</TableCell>
                          <TableCell>{item.qty}</TableCell>
                          <TableCell>
                            {item.itemType === 1 && item.product.tax === 1
                              ? `${
                                  settings.curSymbol +
                                  " " +
                                  (
                                    (parseFloat(store.tax) / 100) *
                                    (item.price * item.qty)
                                  ).toFixed(settings.decimal)
                                }`
                              : t("noTax")}
                          </TableCell>
                          <TableCell>
                            {settings.curSymbol +
                              " " +
                              (item.qty * item.price).toFixed(settings.decimal)}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Box>
            </TableContainer>
          </Grid>

          <Grid item xs={12}>
            <Input
              variant="outlined"
              label={t("leaveNotes")}
              name="notes"
              value={notes}
              multiline
              rows={3}
              inputProps={{ maxLength: 399 }}
              onChange={(e) => setNotes(e.target.value)}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} className="tx-right">
            <Button
              onClick={handleClose}
              variant="contained"
              color="error"
              loading={loading}
              size="large"
            >
              {t("closeReg")}
            </Button>
          </Grid>
        </Grid>
      ) : (
        "Loading..."
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default CloseRegWithDetails;
